import React from 'react';
import {
  Card,
  Button,
  CardHeader,
  CardFooter,
  CardBody,
  CardTitle,
  CardText,
} from 'reactstrap';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

const IconButton = ({ onClick, icon, submitting }) => (
  <button
    className="bg-transparent border-0"
    type="button"
    disabled={submitting}
    onClick={onClick}
  >
    <FontAwesomeIcon icon={icon} />
  </button>
);

const ButtonsRow = ({
  isEditing,
  onEdit,
  onConfirm,
  onCancel,
  iconRight,
  cancelIcon,
  confirmIcon,
  submitting,
}) => {
  if (!iconRight) return null;
  if (isEditing) {
    return (
      <span>
        <IconButton
          onClick={onCancel}
          icon={cancelIcon}
          submitting={submitting}
        />
        <IconButton
          onClick={onConfirm}
          icon={confirmIcon}
          submitting={submitting}
        />
      </span>
    );
  }
  return <IconButton onClick={onEdit} icon={iconRight} />;
};

const BusinessCardWrapper = ({
  iconLeft,
  title,
  iconRight,
  cancelIcon,
  confirmIcon,
  children,
  isEditing,
  onCancel,
  onConfirm,
  onEdit,
  submitting,
}) => {
  return (
    <Card className="mb-4 shadow-2 table-card">
      <CardHeader className="d-flex flex-row justify-content-between">
        <div>
          {iconLeft && <FontAwesomeIcon icon={iconLeft} />}
          {title}
        </div>
        <ButtonsRow
          isEditing={isEditing}
          onEdit={onEdit}
          onCancel={onCancel}
          onConfirm={onConfirm}
          iconRight={iconRight}
          confirmIcon={confirmIcon}
          cancelIcon={cancelIcon}
          submitting={submitting}
        />
      </CardHeader>
      <CardBody className="p-0">{children}</CardBody>
    </Card>
  );
};

export default BusinessCardWrapper;



// WEBPACK FOOTER //
// ./src/components/businessDetail/businessCardWrapper.js